<script lang="ts">
    import {onMount} from "svelte";
    import {
        getEmailTemplates,
        getMailjetTemplates,
        saveEmailTemplate,
        updateEmailTemplateContent
    } from "$lib/calls/mail";
    import {Button, Hr, Label, Select} from "flowbite-svelte";
    import AsyncTypeAhead from "$lib/components/AsyncTypeAhead.svelte";
    import {listEmployees} from "$lib/calls/employee";

    let mailjetTemplates: any[] = [];
    let emailTemplates: any[] = [];
    let selectedTemplate: any = null;
    let originalTemplateHtml: string;
    let existingId:number = 0;
    let selectedEntity:any;
    let placeholders:any[] = [];

    const selectTemplate = async (id) => {
        selectedTemplate = await getMailjetTemplates(id);
        originalTemplateHtml = selectedTemplate[0]['Html-part'];
        placeholders = [];
        const matches = selectedTemplate[0]['Html-part'].match(/{{(.*?)}}/g);
        if (matches) {
            const mappings = matches.map(match => match.replace(/{{|}}/g, '').match(/([^:]+)/g, ''))
            mappings.forEach(mapping => {
                if(!placeholders.find(x => x.name === mapping[1])){
                    placeholders = [...placeholders, {
                        type: mapping[0],
                        name: mapping[1],
                        default: mapping[2]?.replaceAll('"', '')
                    }]
                }

            })

        }
    }

    const fillOut = () => {
        selectedTemplate[0]['Html-part'] = originalTemplateHtml;
        placeholders.forEach(placeholder => {
            const substitution = placeholder.default ? `{{${placeholder.type}:${placeholder.name}:"${placeholder.default}"}}` : `{{${placeholder.type}:${placeholder.name}}}`

            selectedTemplate[0]['Html-part'] = selectedTemplate[0]['Html-part'].replaceAll(substitution, selectedEntity[placeholder.match])
        })
    }
    const save = async () => {
        console.log(placeholders)
        let data = {
            content: selectedTemplate[0]['Html-part'],
            name: selectedTemplate[0].Headers.Subject,
            level: 'import',
            placeholders: []
        }
        if(existingId > 0){
            data.name = emailTemplates.find(x => x.id === existingId).name
            data.level = emailTemplates.find(x => x.id === existingId).level
            await updateEmailTemplateContent(existingId, data)
        } else {
            await saveEmailTemplate(data);
        }

        alert('Saved');
    }
    onMount(async () => {
        mailjetTemplates = await getMailjetTemplates(undefined);
        emailTemplates = await getEmailTemplates()
    })
</script>
<aside class="grid grid-cols-2 gap-3">
    <Label class="space-y-2">
        <span>Mailjet</span>
        <Select on:change={ev => selectTemplate(ev.target.value)}>
            {#each mailjetTemplates as template}
                <option value={template.ID}>{template.Name}</option>
            {/each}
        </Select>
    </Label>
    <Label class="space-y-2">
        <span>Local</span>
        <Select placeholder="Update existing" bind:value={existingId}>
            <option value={0}>Neue Vorlage</option>
            {#each emailTemplates as template}
                <option value={template.id}>{template.name}</option>
            {/each}
        </Select>
    </Label>
</aside>
{#if selectedTemplate}
    <div class="flex gap-3 mt-5">
        <div class="flex-1">
            <div>{@html selectedTemplate[0]['Html-part']}</div>
        </div>
        {#if existingId > 0}
            <div class="flex-1">
                <div>{@html emailTemplates.find(x => x.id === existingId).content}</div>
            </div>
        {/if}

    </div>
    <div class="flex justify-end mt-2">
        <Button on:click={save} >Save</Button>
    </div>
{/if}